import React from 'react';
import cn from 'classnames';
import { Avatar, AvatarFallback, AvatarImage } from '@frontend/shadcn/components/ui/avatar';
import { getColorFromName, getInitials } from '@frontend/app/refresh-components/NameCell';
import { EllipsisLabel } from '@frontend/app/refresh-components/EllipsisLabel';
import { VerifiedBadgeIcon } from '../../../../components/icons/verified-badge-icon';

interface SocialMemberProps extends React.HTMLAttributes<HTMLDivElement> {
  image?: string;
  name: string;
  isVerified?: boolean;
}

const SocialMember: React.FC<SocialMemberProps> = ({
  name,
  image,
  isVerified = false,
  className,
  ...props
}) => (
  <div
    className={cn('flex gap-1 items-center px-2 text-primary', className)}
    {...props}
  >
    <Avatar className="w-6 h-6">
      <AvatarImage src={image} alt={name} />
      <AvatarFallback
        className={cn(
          'flex items-center justify-center h-full w-full text-white font-semibold text-[10px]',
          getColorFromName(name),
        )}
      >
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
    <EllipsisLabel tooltip={name} width="auto">
      {name}
    </EllipsisLabel>
    {isVerified && (
      <VerifiedBadgeIcon className="w-4 h-4" />
    )}
  </div>
);

export default SocialMember;
